var SliderArraySupport = require("enyo-ui/SliderArraySupport");

SliderArraySupport.getRecordUid = function(record) {
    return record.key;
};

module.exports = SliderArraySupport;
